(function (window, document, $) {
    'use strict';

    // $(function () {
    //     let lastScrollTop = 0;
    //     $(window).scroll(function (event) {
    //         let st = $(this).scrollTop();
    //
    //         if (st < lastScrollTop || st < 5) {
    //             // upscroll
    //             $('header').fadeIn(200);
    //             $('#js-redesign-sticky-button').fadeIn(200);
    //         } else {
    //             // downscroll
    //             $('header').fadeOut(200);
    //             $('#js-redesign-sticky-button').fadeOut(200);
    //         }
    //
    //         lastScrollTop = st;
    //
    //     });
    // });

    $(function () {
        $(window).scroll(function (event) {
            let st = $(this).scrollTop()

            if(st > 150 ){
                $('.navbar-inpage').fadeIn(200)
            } else {
                $('.navbar-inpage').fadeOut(200)
            }
        })
    })
}(window, document, jQuery));
